module.exports = __webpack_public_path__ + "static/media/0263_Small.3170c05e.jpg";